import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {I18NService} from "../../utils/i18n.service";

/**
 * Provide custom json parsing capabilities for api requests.
 * @export
 * @class JsonInterceptor
 */
@Injectable()
export class RestLocaleInterceptor implements HttpInterceptor {

    constructor(private i18n : I18NService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const modifiedReq = req.clone({
            headers: req.headers.set('Accept-Language', this.i18n ? this.i18n.locale : I18NService.DEFAULT_LOCALE),
        });
        return next.handle(modifiedReq);
    }

}
